export const iconPropsFunc = (props = {}) => {
  return {
    props: {
      width: {
        type: String,
        default: props.width || "14",
      },
      height: {
        type: String,
        default: props.height || "14",
      },
      fill: {
        type: String,
        default: props.fill || "currentColor",
      },
    },
  };
};
